export const shellInfo = {
  name: process.env.BUILD_PCKG_NAME,
  version: process.env.BUILD_PCKG_VERSION,
};
